import { get, post } from '@/utils/request'

const mallAPI = {
  product: '/api/product',
  order: '/api/order',
  pay: '/api/pay',
  seckill: '/api/seckill'
}

export function getProducts(queryParams) {
  return get(mallAPI.product + '/list', queryParams)
}

export function getSeckillProducts() {
  return get(mallAPI.product + '/seckill/product')
}

export function getProductDetail(skuId) {
  return get(mallAPI.product + '/sku?skuId=' + skuId)
}

export function createSeckillActivity(jsonData) {
  // return post(mallAPI.seckill + '/create_seckill', jsonData)
  return post(mallAPI.product + '/seckill/product', jsonData)
}

export function getSeckillActivityList(queryParams) {
  return get(mallAPI.product + '/seckill/list', queryParams)
}

export function warmupSeckill(jsonData) {
  return post(mallAPI.product + '/seckill/warmup', jsonData)
}

export function getSeckillPath() {
  return get(mallAPI.seckill + '/path')
}

export function doSeckill(path, jsonData) {
  return post(mallAPI.seckill + '/' + path + '/do_seckill', jsonData)
}

export function getSeckillResult(queryParams) {
  return get(mallAPI.seckill + '/result', queryParams)
}

export function prePayOrder(jsonData) {
  return post(mallAPI.order + '/pay/prepay', jsonData)
}

export function getOrderDetail(queryParams) {
  return get(mallAPI.order + '/detail', queryParams)
}

export function getOrderList(queryParams) {
  return get(mallAPI.order + '/list', queryParams)
}

export function cancelOrder(jsonData) {
  return post(mallAPI.order + '/cancel', jsonData)
}

export function payOrder(jsonData) {
  return post(mallAPI.pay + '/trigger', jsonData)
}
